export const COMMAND_CENTER_FAST_DAYS_AHEAD = 90;
export const COMMAND_CENTER_FULL_DAYS_AHEAD = 365;
